import React from "react";
import styles from "../../offer/UserNote.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "../../../../common/forms/Form";
import FormInput from "../../../../common/forms/FormInput";

type Props = {
  handleMemo: (value: string | undefined, name: string) => void;
  memo?: string;
};
const MemoInput: React.FC<Props> = ({ handleMemo, memo }) => {
  return (
    <div className={styles["f-userMemo"]}>
      <div className={styles["f-userMemo__header"]}>
        <div>
          <FontAwesomeIcon icon={["far", "file-alt"]} />
          <span>メモ</span>
        </div>
      </div>
      <div className={styles["f-userMemo__wrapper"]}>
        <Form handler={() => {}}>
          <FormInput
            type="textarea"
            label=""
            name="sonic_memo"
            handler={(value, name) => {
              if (value === undefined || typeof value === "string") {
                handleMemo(value, name);
              }
            }}
            initial_value={memo}
          />
        </Form>
      </div>
    </div>
  );
};

export default MemoInput;
